var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.111 7.556h-2.667V4.889a.889.889 0 10-1.777 0v2.667a1.778 1.778 0 001.777 1.777h2.667a.889.889 0 100-1.777zM7.556 9.333a1.778 1.778 0 001.777-1.777V4.889a.889.889 0 10-1.777 0v2.667H4.889a.889.889 0 100 1.777h2.667zm0 7.111H4.889a.889.889 0 110-1.777h2.667a1.778 1.778 0 011.777 1.777v2.667a.889.889 0 11-1.777 0v-2.667zm8.888-1.777a1.778 1.778 0 00-1.777 1.777v2.667a.889.889 0 101.777 0v-2.667h2.667a.889.889 0 100-1.777h-2.667z",
    fill: "currentColor"
  })));
}
export default SvgMinimize;